import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import DisplayError from "../../dumb/DisplayError";
import { unassignMemoryFromProject, unassignMemoryFromTitle } from "../../../redux/ducks/memory";

const UnassignMemory = props => {
    const [show, hide, renderModal] = useModal();
    const [d_unassignMemoryFromProject, statusP, errorP, eventP] = useStatusThunk(unassignMemoryFromProject);
    const [d_unassignMemoryFromTitle, statusT, errorT, eventT] = useStatusThunk(unassignMemoryFromTitle);

    eventP.onSuccess = () => hide();
    eventT.onSuccess = () => hide();

    return (
        <React.Fragment>
            <button className={"button button--danger " + props.className} onClick={show}>Unassign</button>
            {renderModal(
                <div>
                    <div className="group">
                        <DisplayError error={errorP} />
                        <DisplayError error={errorT} />
                    </div>

                    <LoadingButton loading={statusP == "pending" || statusT == "pending"} className={"button--danger"} onClick={() => {
                        if (props.projectID) {
                            d_unassignMemoryFromProject({ projectID: props.projectID, memoryIDs: props.memoryIDs });
                        } else if (props.titleID) {
                            d_unassignMemoryFromTitle({ titleID: props.titleID, memoryIDs: props.memoryIDs });
                        }
                    }}>Unassign Memory</LoadingButton>
                </div>
            )}
        </React.Fragment>
    )
}

export default UnassignMemory;